import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { PageRoutes, RootType, useMst } from '../../internal';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmAdmin.module.scss';
import { InputField } from '../../components/UI/input/InputField';
import { Button } from '../../components/UI/buttons/regular/Button';
import { PasswordField } from '../../components/UI/password/PasswordField';

const ConfirmAdmin = observer(() => {
  const { t } = useTranslation();
  const root: RootType = useMst();
  const {
    currentPage,
    currentPage: {
      getEmailModel,
      getPasswordModel,
      getConfirmPasswordModel,
      getConfirmBtnModel,
    },
  } = root;

  useEffect(() => {
    const handleSubmit = (e: { key: string }) => {
      if (e.key === 'Enter') {
        getConfirmBtnModel().click();
      }
    };
    window.addEventListener('keypress', handleSubmit);
    return () => {
      window.removeEventListener('keypress', handleSubmit);
    };
  }, []);

  return currentPage && currentPage.id === PageRoutes.ConfirmAdmin.id ? (
    <div className={styles.Container}>
      <div className={styles.Main}>
        <h1 className={styles.Title}>{t('basic:confirm_admin')}</h1>
        <form
          onSubmit={(event) => {
            event.preventDefault();
          }}
          className={styles.Form}
          noValidate
        >
          <div className={styles.OuterInputFieldContainer}>
            <InputField model={getEmailModel()} />
          </div>

          <div className={styles.OuterInputFieldContainer}>
            <PasswordField model={getPasswordModel()} />
          </div>
          <div className={styles.OuterInputFieldContainer}>
            <PasswordField model={getConfirmPasswordModel()} />
          </div>
          <div className={styles.BtnContainer}>
            <Button model={getConfirmBtnModel()}></Button>
          </div>
        </form>
      </div>
    </div>
  ) : null;
});

export default ConfirmAdmin;
